import { MasterCrudPage } from '@/components/MasterCrudPage.jsx';

export default function EmployeeCategoriesPage() {
  return (
    <MasterCrudPage
      title="Employee Categories"
      description="Employee classification categories"
      endpoint="/employee-categories"
      queryKey={['employeeCategories']}
      fields={[
        { name: 'name', label: 'Name', required: true },
        { name: 'description', label: 'Description', type: 'textarea' },
      ]}
      columns={[
        { key: 'name', header: 'Name', sortable: true },
        { key: 'description', header: 'Description' },
      ]}
    />
  );
}
